import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "w-[250px] px-5" }

import { NkStack, NkGroup } from '@/core/components';
import DashboardNavigation from '@/entities/app/components/navigation/DashboardNavigation.vue';

import { NAVIGATION_HEIGHT } from '@/entities/app/components/navigation/navigation.styled';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminLayout',
  setup(__props) {

const store = useStore();

const entries = [
  {
    name: 'Dashboard',
    to: { name: 'admin-dashboard' },
    access: 'none',
  },
  {
    name: 'Organizations',
    to: { name: 'admin-organizations' },
    access: 'all',
  },
  {
    name: 'Users',
    to: { name: 'admin-users' },
    access: 'responsible',
  },
  {
    name: 'Experts',
    to: { name: 'admin-experts' },
    access: 'responsible',
  },
  {
    name: 'Profiles',
    to: { name: 'admin-profiles' },
    access: 'admin',
  },
  {
    name: 'Severities',
    to: { name: 'admin-severities' },
    access: 'admin',
  },
  {
    name: 'Weathers',
    to: { name: 'admin-weathers' },
    access: 'admin',
  },
  {
    name: 'Types',
    to: { name: 'admin-types' },
    access: 'admin',
  },
  {
    name: 'Services',
    to: { name: 'admin-services' },
    access: 'admin',
  },
  {
    name: 'Annotation types',
    to: { name: 'admin-annotation-types' },
    access: 'admin',
  },
  {
    name: 'Parc Test',
    to: { name: 'admin-parc-test' },
    access: 'admin',
  },
];

const hasAccess = (access: string) => {
  if (access === 'admin') {
    return store.getters['connection/isGranted'](['ROLE_ADMIN'])
  }

  if ( access === 'responsible' ) {
    return store.getters['connection/isGranted'](['ROLE_RESPONSIBLE']) || store.getters['connection/isGranted'](['ROLE_ADMIN'])
  }

  return access === 'all';
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(NkStack), { spacing: 0 }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(DashboardNavigation)
      ]),
      _createElementVNode("div", {
        class: "pt-7 pb-9 overflow-y-auto overflow-x-hidden",
        style: _normalizeStyle({ height: `calc(100vh - ${_unref(NAVIGATION_HEIGHT)})`})
      }, [
        _createVNode(_unref(NkGroup), {
          spacing: 0,
          align: "start",
          "no-wrap": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(NkStack), null, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(entries, ({name, to, access}) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: name }, [
                      (hasAccess(access))
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: to
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "w-full justify-start",
                                text: "",
                                bg: _ctx.$route.matched.some((route) => route.name === to.name)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(name), 1)
                                ]),
                                _: 2
                              }, 1032, ["bg"])
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 64))
                ]),
                _: 1
              })
            ]),
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })
      ], 4)
    ]),
    _: 3
  }))
}
}

})